// LIBRERIE/IMPORTS
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

// IMG

interface SubHeaderHomeProps {
  agencyName?: string;
  isSeo: boolean;
  showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({ showSearchForm }) => {

  const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
  const { t } = useTranslation();

  // animazioni

  const [animated, setAnimated] = useState(false);
  useEffect(() => {
      const timer = setTimeout(() => {
        setAnimated(true);
      }, 4500);
       return () => clearTimeout(timer);
  }, [])

  if (loading) return <LoadingIndicator />;
  if (error) return <SlowLoadComponent />;
  if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

  return (
    <section className="banner">
            
            <span className={`d-none d-lg-inline ${animated ? 'visible' : 'no-visible'}`}>Immobiliare</span>
            <span className={`d-none d-lg-inline ${animated ? 'visible' : 'no-visible'}`}>Marzocchi</span>
            {showSearchForm && <PropertySearchField searchData={{}} />}
            <div className="triangle-left"></div>
            <div className="triangle-right"></div>
    </section>
  );
};

export default SubHeaderHome;